





























































































































import { Component } from "vue-property-decorator";
import { DepositVueGB } from "@/extensions/contract/DepositVueGB";
import Requisites from "@/components/contracts/Requisites.vue";
import ArrestDetails from "@/components/contracts/ArrestDetails.vue";
import ForecastModal from "@/components/contracts/ForecastModal.vue";
import ContractDetails from "@/components/contracts/ContractDetails.vue";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: {
    BackLink,
    ContractDetails,
    Requisites,
    ArrestDetails,
    ForecastModal
  }
})
export default class Deposit extends DepositVueGB {
}
